export default "__VITE_ASSET__DvKOQzb4__"